<template>
    <div class="star-mgt-delis" >
        <div class="headerimg">
            <img :src="message.starlogourl" alt="satrMgtHeader">
        </div>
        <div class="details">

            <div class="title">
                <p class="name">{{message.starname}}</p>
                <div class="table-position" v-if="message.status !== 100">
                    <a :href="'/#/starMgt/star/CreateStarMgt?innerid='+message.innerid"><el-button>编辑</el-button></a>
                    <!--<span>|</span>-->
                    <!--<el-button v-if="message.status == 1" @click="updateStarByStatus(11)">隐藏</el-button>-->
                    <!--<el-button v-if="message.status == 11" @click="updateStarByStatus(1)">显示</el-button>-->
                    <span>|</span>
                    <el-button @click="updateStarByStatus(100)">解散</el-button>
                </div>
            </div>
            <p class="detext">{{ message.stardesp }}</p>
            <p class="table-status status">
                <span class="item">状态:
                    <span v-if="message.status == 1" class="status-1">正常</span>
                    <!--<span v-if="message.status == 11" class="status-3">隐藏</span>-->
                    <span v-if="message.status == 100" class="status-2">解散</span>
                </span>
                <span class="item">成员数：{{message.membercount}}</span>
                <span class="item">主题数：{{message.subjectcount}}</span>
                <span class="item">资料数：{{message.filecount}}</span>
                <span class="item">笔记数：{{message.notescount}}</span>
            </p>
        </div>
    </div>
</template>

<script>
import {getStarInfo,updateStarByStatus} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {getCookie} from '@/common/js/tools' // 引入 tools 库
import Loading from 'base/loading/loading' // 引入 loading 组件
import {mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery' // 引入 jquery 组件
export default {
    name: 'StarMgtDelis',
    props: ['message'], // 接收父类传参 星球详细数据
    data() {
        return {
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            innerid: this.$route.query.innerid // 星球编号
        }
    },
    mounted() {
    },
    methods: {
        // 修改星球状态
        updateStarByStatus(status) {
            let txt // 文案
            switch (status) {
                case 1:
                    txt = '您确定公开该星球吗？'
                    break
                case 11:
                    txt = '您确定隐藏该星球吗？'
                    break
                case 100:
                    txt = '您确定解散该星球吗？'
                    break
            }

            this.$confirm(txt, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let data = {

                    LoginToken: this.token,
                    innerid: this.innerid,
                    status: status
                }

                this.setLoading(true)

                updateStarByStatus({
                    data: data,
                    success: data => {
                        this.setLoading(false)
                        if (data.code === '000') {

                            // 修改页面状态
                            this.message.status = status;
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            })
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        console.log(data)
                    }
                })
            }).catch(() => {
            })
        },
        ...mapActions(
            ['setLoading']
        )
    }
}
</script>

<style lang="scss">
    .star-mgt-delis {
        padding: 15px 30px;
        height: 180px;
        box-sizing: border-box;
        background: #FAFAFA;

        .headerimg {
            float: left;
            width: 170px;
            img {
                width: 150px;
                /*width: calc(100% - 20px);*/
                height: 150px;
                border-radius: 5px;
            }
        }

        .details {
            float: right;
            width: calc(100% - 170px);
        }

        .title {
            margin-top: 7px;
            height: 32px;
            overflow: hidden;
            .name {
                float: left;
                font-size: 16px;
                font-weight: 500;
                color: #303133;
                line-height: 32px;
            }
            .table-position {
                float: right;
            }
        }

        .detext {
            margin-top: 9px;
            width: 70%;
            /*width: 765px;*/
            color: #606266;
            font-size: 15px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .status {
            margin-top: 15px;
            font-size: 14px;

            .item {
                margin-right: 10px;
                color: #909399;
            }

        }
        .table-status {
            span {
                font-weight: normal;
            }
        }

    }
</style>
